// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Vm","textBadge":"e_Wm","buttonBlock":"e_Xm"};